// Which Read of a company is "the latest". Mirrors apps/api/src/lib/read-order.ts, so the header, All findings and
// the Inbox name the same Read the API scores.

/** The most recently created run; no creation time falls back to signing time; equal creation times to signing time, then id. */
export interface ReadOrderFields {
  id: string;
  committed_at?: string | null;
  report?: { signed_at?: string | null } | null;
}

const parse = (value: string | null | undefined): number | null => {
  if (!value) return null;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
};

export function readOrderTime(read: ReadOrderFields): number {
  return parse(read.committed_at) ?? parse(read.report?.signed_at) ?? 0;
}

/** Sort comparator, newest Read first. */
export function compareReadsNewestFirst(a: ReadOrderFields, b: ReadOrderFields): number {
  return readOrderTime(b) - readOrderTime(a)
    || (parse(b.report?.signed_at) ?? 0) - (parse(a.report?.signed_at) ?? 0)
    || b.id.localeCompare(a.id);
}
